export const messages = {
  en: {
    attendanceClassesManage: {
      title: 'Attendance Settings',
      document: 'Document',
      add: 'Add',
      classesId: 'Classes ID',
      classesName: 'Classes Name',
      timeOffset: 'Clock-in Range',
      lateOffset: 'Late Range',
      leaveOffset: 'Early Leave Range',
      maxLastOffset: 'Last Clock-out Range',
      operation: 'Operation',
      minute: 'minute',
      fetchError: 'Failed to fetch attendance classes data'
    },
    addAttendanceClasses: {
      title: 'Add Attendance Classes',
      classesName: 'Classes Name',
      classesNamePlaceholder: 'Required, please enter classes name',
      classesNameRequired: 'Classes name is required',
      classesNameMaxLength: 'Classes name format error',
      timeOffset: 'Clock-in Range',
      timeOffsetPlaceholder: 'Required, please enter clock-in range (minutes)',
      timeOffsetRequired: 'Clock-in range is required',
      timeOffsetFormat: 'Clock-in range format error',
      lateOffset: 'Late Range',
      lateOffsetPlaceholder: 'Required, please enter late range (minutes)',
      lateOffsetRequired: 'Late range is required',
      lateOffsetMaxLength: 'Late range error',
      leaveOffset: 'Early Leave Range',
      leaveOffsetPlaceholder: 'Required, please enter early leave range (minutes)',
      leaveOffsetRequired: 'Early leave range is required',
      leaveOffsetMaxLength: 'Early leave range error',
      maxLastOffset: 'Last Clock-out Range',
      maxLastOffsetPlaceholder: 'Required, please enter last clock-out range (minutes)',
      maxLastOffsetRequired: 'Last clock-out range is required',
      saveSuccess: 'Added successfully'
    },
    editAttendanceClasses: {
      title: 'Edit Attendance Classes',
      classesName: 'Classes Name',
      classesNamePlaceholder: 'Required, please enter classes name',
      classesNameRequired: 'Classes name is required',
      classesNameMaxLength: 'Classes name format error',
      timeOffset: 'Clock-in Range',
      timeOffsetPlaceholder: 'Required, please enter clock-in range (minutes)',
      timeOffsetRequired: 'Clock-in range is required',
      timeOffsetFormat: 'Clock-in range format error',
      lateOffset: 'Late Range',
      lateOffsetPlaceholder: 'Required, please enter late range (minutes)',
      lateOffsetRequired: 'Late range is required',
      lateOffsetMaxLength: 'Late range error',
      leaveOffset: 'Early Leave Range',
      leaveOffsetPlaceholder: 'Required, please enter early leave range (minutes)',
      leaveOffsetRequired: 'Early leave range is required',
      leaveOffsetMaxLength: 'Early leave range error',
      maxLastOffset: 'Last Clock-out Range',
      maxLastOffsetPlaceholder: 'Required, please enter last clock-out range (minutes)',
      maxLastOffsetRequired: 'Last clock-out range is required',
      classesIdRequired: 'Classes ID is required',
      editSuccess: 'Modified successfully'
    },
    deleteAttendanceClasses: {
      title: 'Confirm Operation',
      confirmText: 'Are you sure to delete this attendance classes?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Deleted successfully',
      deleteError: 'Failed to delete attendance classes'
    }
  },
  zh: {
    attendanceClassesManage: {
      title: '考勤设置',
      document: '文档',
      add: '添加',
      classesId: '班组ID',
      classesName: '班组名称',
      timeOffset: '打卡范围',
      lateOffset: '迟到范围',
      leaveOffset: '早退范围',
      maxLastOffset: '当日下班范围',
      operation: '操作',
      minute: '分钟',
      fetchError: '获取考勤班组数据失败'
    },
    addAttendanceClasses: {
      title: '添加考勤班组',
      classesName: '班次名称',
      classesNamePlaceholder: '必填，请填写班次名称',
      classesNameRequired: '班次名称不能为空',
      classesNameMaxLength: '班次名称格式错误',
      timeOffset: '打卡范围',
      timeOffsetPlaceholder: '必填，请填写打卡范围(分钟)',
      timeOffsetRequired: '打卡范围不能为空',
      timeOffsetFormat: '打卡范围格式错误',
      lateOffset: '迟到范围',
      lateOffsetPlaceholder: '必填，请填写迟到范围（分钟）',
      lateOffsetRequired: '迟到范围不能为空',
      lateOffsetMaxLength: '迟到范围错误',
      leaveOffset: '早退范围',
      leaveOffsetPlaceholder: '必填，请填写早退范围（分钟）',
      leaveOffsetRequired: '早退范围不能为空',
      leaveOffsetMaxLength: '早退范围错误',
      maxLastOffset: '当日下班范围',
      maxLastOffsetPlaceholder: '必填，请填写当日最后一次下班打卡范围（分钟）',
      maxLastOffsetRequired: '当日下班范围不能为空',
      saveSuccess: '添加成功'
    },
    editAttendanceClasses: {
      title: '修改考勤班组',
      classesName: '班次名称',
      classesNamePlaceholder: '必填，请填写班次名称',
      classesNameRequired: '班次名称不能为空',
      classesNameMaxLength: '班次名称格式错误',
      timeOffset: '打卡范围',
      timeOffsetPlaceholder: '必填，请填写打卡范围(分钟)',
      timeOffsetRequired: '打卡范围不能为空',
      timeOffsetFormat: '打卡范围格式错误',
      lateOffset: '迟到范围',
      lateOffsetPlaceholder: '必填，请填写迟到范围（分钟）',
      lateOffsetRequired: '迟到范围不能为空',
      lateOffsetMaxLength: '迟到范围错误',
      leaveOffset: '早退范围',
      leaveOffsetPlaceholder: '必填，请填写早退范围（分钟）',
      leaveOffsetRequired: '早退范围不能为空',
      leaveOffsetMaxLength: '早退范围错误',
      maxLastOffset: '当日下班范围',
      maxLastOffsetPlaceholder: '必填，请填写当日最后一次下班打卡范围（分钟）',
      maxLastOffsetRequired: '当日下班范围不能为空',
      classesIdRequired: '班组ID不能为空',
      editSuccess: '修改成功'
    },
    deleteAttendanceClasses: {
      title: '请确认您的操作',
      confirmText: '确定删除考勤班组吗？',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功',
      deleteError: '删除考勤班组失败'
    }
  }
}